export const PDF_TRON_LICENCE_KEY = "Tesco SW a.s.:OEM:TEAF::B+:AMS(20241026):2EB6CE43B66C9D5849994E616F5F0CF1D3F15F8769C42C20B986448231F5C7";
// licence pro verzi 8
//export const PDF_TRON_LICENCE_KEY = "Tesco SW a.s.(tescosw.cz):OEM:TEAF::B+:AMS(20221026):FAF565B16AB64D0BDABBC8B253084F02404F4D831A15CD14E4C42C20B986448231F5C7";
// licence pro verzi <8
//export const PDF_TRON_LICENCE_KEY = "Tesco SW a.s.(tescosw.cz):OEM:TEAF::B+:AMS(20211026):EAF525B16AB64D0B1ABBC8B253084F02404F4D831A15CD14E4C42C20B986448231F5C7";
